import { MotionValue } from '../index.js';

var isMotionValue = function isMotionValue(value) {
  return value instanceof MotionValue;
};

export { isMotionValue };